import React, { useContext, useEffect } from 'react';

export const SuccessHandler = ({ msg, context }) => {
  const { toFalse } = useContext(context);

  useEffect(() => {
    let t = setTimeout(() => {
      toFalse('SET_FEEDBACK_SUCCESS');
    }, 4000);

    return () => {
      clearTimeout(t);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <p>{msg}</p>
      <div className='cncl-btn'></div>
    </div>
  );
};
